const ACCESS_TOKEN_REF_NAME = "access_token_og";

export function setAccessToken(accessToken: string) {
  localStorage.setItem(ACCESS_TOKEN_REF_NAME, accessToken);
}

export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_REF_NAME);
}
